import axios from "axios";

export default {
  getStandingsByCompetitionId(competitionId, phaseId) {
    return axios
      .get(process.env.VUE_APP_API_URL + "standings/competition/" + competitionId + "/phase/" + phaseId)
      .then((response) => {
        let data = response.data.data;
        data = data.map((standing) => {
          let name = standing.team.name;
          if (/playoff/i.test(name)) {
            standing.team.name = name.replace(/playoff/i, "").trim() + "*";
          }
          return standing;
        });
        return data;
      });
  },
};
